import React from 'react';

export const ThinLeftArrow = props => (
  <svg width={18} height={30} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 15.318c0-.468.187-.915.513-1.229L14.795.421a1.474 1.474 0 0 1 2.179.128c.57.68.515 1.724-.12 2.328L3.889 15.289l12.938 11.807c.648.591.725 1.63.172 2.325-.554.693-1.529.776-2.177.184L.54 16.572A1.695 1.695 0 0 1 0 15.337v-.019Z"
      fill="#BCC6CA"
    />
  </svg>
);
